import React from 'react';
import { BookOpen, Target, Zap, Trophy } from 'lucide-react';

const features = [
  {
    icon: BookOpen,
    title: 'Genre-Specific Titles',
    description: 'Titles tailored for fiction, non-fiction, academic, and children\'s books.'
  },
  {
    icon: Target,
    title: 'Multiple Styles',
    description: 'Choose from various writing styles and tones for your book.'
  },
  {
    icon: Zap,
    title: 'Instant Generation',
    description: 'Get unique book title suggestions in seconds.'
  },
  {
    icon: Trophy,
    title: 'Best-Seller Worthy',
    description: 'Titles that capture attention and intrigue readers.'
  }
];

export default function BookFeatures() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Why Choose Our Book Title Generator?
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center p-6 rounded-lg border border-purple-200 hover:shadow-lg transition-shadow">
              <feature.icon className="w-12 h-12 text-purple-500 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}